import React from 'react';
import { usePlanningActualState } from '../Context/index';

function SalesTableTotal({ years }) {
  const { checkVisible, getOvarAllFieldTotal, getVSOverallTotal } = usePlanningActualState();

  const sales = [
    {
      keyName: 'plannedSales',
      name: 'Planned Sales',
    },
    {
      keyName: 'actualSales',
      name: 'Actual Sales',
    },
    {
      keyName: 'plannedMix',
      name: 'Planned Mix (%)',
    },
    {
      keyName: 'actualMix',
      name: 'Actual Mix (%)',
    },
  ];

  return (
    <>
      {(years ?? [])?.map((currentYear, yearIndex) => {
        return (
          <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
            <thead>
              <tr>
                {yearIndex === 0 && <th className="w-200px" />}
                {sales.map((salesItem, i) => {
                  const isVisible = checkVisible(salesItem.keyName);
                  return (
                    isVisible && (
                      <th key={i} className="w-200px">
                        <span>
                          {currentYear}&nbsp;
                          {salesItem.name}
                        </span>
                      </th>
                    )
                  );
                })}
              </tr>
            </thead>
            <tbody>
              <tr>
                {yearIndex === 0 && <td>Total</td>}
                {sales.map((salesItem, i) => {
                  const isVisible = checkVisible(salesItem.keyName);
                  return isVisible && <td key={i}>{getOvarAllFieldTotal(salesItem.keyName, yearIndex, currentYear)}</td>;
                })}
              </tr>
            </tbody>
          </table>
        );
      })}
      <table className="table custom-table layout-fixed font-13 mr-3">
        <thead>
          <tr>
            {(years ?? []).map((childYear, i) => {
              return (
                i > 0 && (
                  <th key={i} className="w-200px">
                    <span>
                      {years[0]} vs {childYear} (%)
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            {(years ?? []).map((eleYear, iYear) => {
              return (
                iYear > 0 && (
                  <td key={iYear} className="w-200px">
                    <span>{getVSOverallTotal('plannedSales', 'actualSales', eleYear)}</span>
                  </td>
                )
              );
            })}
          </tr>
        </tbody>
      </table>
    </>
  );
}
export default SalesTableTotal;
